import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { login } from "./login";
import { useNavigate } from "react-router-dom";
import { getHomeRouteForLoggedInUser } from "@utils";
import { handleLogin, handleSetUser } from "@store/authentication";
import { useDispatch } from "react-redux";
import { useUpdateUserGroup } from "@src/features/user";
import { getUser } from "./getUser";
import {useContext} from "react";
import abilityList from "@configs/acl/initialAbility";
import { AbilityContext } from "@src/utility/context/Can";

export const register = ({ data }) => {
  return axios.post("/auth/users/", data);
};

export const useRegisterUser = ({ config } = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const updateUserGroupMutation = useUpdateUserGroup();

  return useMutation({
    onSuccess: (data) => {
      toast.success("Sign up successfully");
      const userObj = JSON.parse(data.config.data);
      login({ username: userObj.username, password: userObj.password }).then(
        (res) => {
          const data = {
            accessToken: res.data.access,
            refreshToken: res.data.refresh,
          };
          dispatch(handleLogin(data));
          getUser().then((userRes) => {
            const userData = userRes.data;
            updateUserGroupMutation.mutateAsync({
              data: { user_id: userData.id, group_id: 8 },
            });
            const data = {
              ...userData,
              accessToken: res.data.access,
              refreshToken: res.data.refresh,
              role: "Player",
            };
            dispatch(handleSetUser(data));
            const defaultAbility = abilityList['Player'];
            ability.update(defaultAbility);
            navigate(getHomeRouteForLoggedInUser(data?.role));
            toast.success("signin successfully");
          });
        }
      );
    },
    ...config,
    mutationFn: register,
  });
};
